import appConstants from '@appConstants';
import { getStatusLabelForShipment } from '../../../Utils';
import { useNavigate } from 'react-router-dom';

const ProNumber = ({
  stopData,
  classNames,
  highlighted,
  route,
  classes,
  staticClientStatusLists,
  enableReturnExceptionReasonLabels
}) => {
  const navigate = useNavigate();
  const lastShipment = stopData.shipments.length - 1;
  const openProDetails = (proId) => {
    const data = {
      apiName: 'GetReportingProDetails',
      queryParams: `proNumber=${proId}&isActivePro=${route.isLiveDispatch}`,
      proId,
      driverRouteDetails: route,
      hideViewProImages: true,
      freightBillDetailsApiName: route.isLiveDispatch ? null : 'GetReportFreightBillDetails',
      freightBillDetailsQueryParams: route.isLiveDispatch ? null : `proNumber=${proId}`
    };
    navigate(`?proId=${proId}`, {
      state: { data: data, closeOnRefresh: true }
    });
  };
  return stopData.shipments.map((shipment, index) => {
    const status = getStatusLabelForShipment(
      shipment,
      staticClientStatusLists,
      enableReturnExceptionReasonLabels
    );
    const statusText = status ? ` (${status})` : '';
    return (
      <span
        key={shipment.proId}
        className={`${classes.underline} ${classNames(
          status !== appConstants.DELIVERY_CODE.DC,
          shipment.proId == highlighted
        )}`}
        onClick={() => openProDetails(shipment.proId)}>{`${shipment.proId}${statusText}${
        index !== lastShipment ? ',  ' : ''
      }`}</span>
    );
  });
};

export default ProNumber;
